/**
 * Add .js-active to body tag. 
 * If the .js-active class is missing from the body tag then the user does not have JavaScript enabled or there is a JS error.
 * If JavaScript is disabled or not working, the site will rely on CSS to make the sub menus work instead of JS.
 */
document.addEventListener('DOMContentLoaded', function() {
	if(document.body) {
		document.body.classList.add('js-active');
	}
});


// Collapse all submenus
function collapseAllSubMenus() {
	document.querySelectorAll("[aria-expanded=true] + .sub-menu").forEach(subMenu => {
		// Collapse 1st level submenu
		const associatedToggleButton = document.querySelector(`[aria-controls="${subMenu.id}"]`);
		associatedToggleButton?.setAttribute("aria-expanded", "false");
		associatedToggleButton?.removeAttribute("aria-label");

		// Collapse 2nd level submenu
		subMenu.querySelector(".wp-block-fuel-sub-menu-tab-link[aria-selected=true]")?.setAttribute("aria-selected", "false"); // change trigger aira-selected to false
		subMenu.querySelector(`.visible`)?.classList.remove("visible"); // remove visible class from the 2nd level submenu
	});
}


function toggleSubMenu(subMenuTrigger) {
	const ariaControls = subMenuTrigger.getAttribute("aria-controls");
	const subMenu = document.getElementById(ariaControls);

	if (subMenu) {
		const isExpanded = subMenuTrigger.getAttribute("aria-expanded") === "true";
		collapseAllSubMenus();
		subMenuTrigger.setAttribute("aria-expanded", isExpanded ? "false" : "true");
		subMenuTrigger.removeAttribute("aria-label");
	}
}


document.addEventListener("click", (event) => {
	const toggleButton = event.target.closest(".sub-menu-trigger");
	if (toggleButton) {
		event.preventDefault();
		toggleSubMenu(toggleButton);
	} else {
		const clickedOutsideSubMenu = !event.target.closest("[aria-expanded=true] + .sub-menu");
		if (clickedOutsideSubMenu) {
			collapseAllSubMenus();
		}
	}
});


// Function to check if keydown target is inside the menu
function isTargetWithinMenu(target) {
	const menuWrapper = target.closest(".primary-menu");
	return menuWrapper && menuWrapper.contains(target);
}


/**
 * Keyboard support rules pulled from ARIA Authoring Practices Guide (APG)
 * BUG: Does not work for sub menu.
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/examples/disclosure-navigation/
 * 
 */
document.addEventListener("keydown", (event) => {
	if (!isTargetWithinMenu(event.target)) { return; } // Exit if the target is not within .primary-menu

	const menuWrapper = event.target.closest(".primary-menu");
	const activeItem = document.activeElement;

	if (event.key === "Escape") {
		const activeSubMenus = menuWrapper.querySelectorAll("[aria-expanded=true] + .sub-menu");
		activeSubMenus.forEach((subMenu) => {
			const associatedToggleButton = document.querySelector(`[aria-controls="${subMenu.id}"]`);
			associatedToggleButton?.setAttribute("aria-expanded", "false");
			associatedToggleButton?.focus();
		});
	} else if (event.key === " " || event.key === "Enter") {
		if(event.target.closest("[aria-expanded]")) {
			event.preventDefault();
			const activeToggleButton = activeItem.closest(".sub-menu-trigger");

			if (activeToggleButton) {
				toggleSubMenu(activeToggleButton);
			}
		}
	}
});


/*
 * @see https://blog.logrocket.com/build-accessible-user-interface-tabs-javascript/
 */
function fm_runTabs() {
	const TABBLOCKS = document.querySelectorAll(".sub-menu");

	function showActivePanel(selectedId, TABPANELS) {
		TABPANELS.forEach(e => {
			e.hidden = true;
			e.classList.remove("visible");
		});
		const activePanel = document.querySelector(`[aria-labelledby="${selectedId}"]`);
		activePanel.removeAttribute("hidden");
		activePanel.classList.add("visible");
		activePanel.focus();
	}

	function setSelectedTab(selectedId, TABS, TABPANELS) {
		TABPANELS[0].classList.remove("visible");
		TABS.forEach(e => {
			const id = e.getAttribute("id");
			if (id === selectedId) {
				e.removeAttribute("tabindex");
				e.setAttribute("aria-selected", "true");
				e.setAttribute("aria-expanded", "true");
			} else {
				//e.setAttribute("tabindex", "-1");
				e.setAttribute("aria-selected", "false");
				e.setAttribute("aria-expanded", "false");
			}
		});
	}


	function handleClick(TABS, TABPANELS) {
		const activateTab = (element, e) => {
			if (e.type === "keydown" && e.keyCode !== 32 && e.keyCode !== 13) return;
			console.log(e.type === "click" ? "triggered" : "Keyboard triggered");
			setSelectedTab(element.id, TABS, TABPANELS);
			showActivePanel(element.id, TABPANELS);
			e.preventDefault();
		};
		
		TABS.forEach(element => {
			element.addEventListener("click", e => activateTab(element, e));
			element.addEventListener("keydown", e => activateTab(element, e));
		});
	}
		  



	function resetTabsVisibility(TABBLOCK) {
		const resetVisibility = e => {
			if (e.type === "keydown" && e.keyCode !== 32) return;
			e.preventDefault();
		
			const visible = TABBLOCK.querySelector('.visible');
			visible?.classList.remove("visible");
		
			const selected = TABBLOCK.querySelector('[aria-selected="true"]');
			if (selected) {
			selected.setAttribute('aria-selected', 'false');
			selected.setAttribute("aria-expanded", "false");
			selected.focus();
			}
		};
		
		TABBLOCK.querySelectorAll('.back-to-tabs-btn').forEach(button => {
			button.addEventListener('click', resetVisibility);
			button.addEventListener('keydown', resetVisibility);
		});
	}
		  

	TABBLOCKS.forEach(TABBLOCK => {
		TABBLOCK.removeAttribute("tabindex");
		const TABS = Array.from(TABBLOCK.querySelectorAll(".tab-link"));
		const TABPANELS = Array.from(TABBLOCK.querySelectorAll(".tabpanel"));
		handleClick(TABS, TABPANELS);
		resetTabsVisibility(TABBLOCK);
	});
}





if (typeof wp !== 'undefined' && wp.data.select('core/editor')) {
	// This code runs in the WP Editor after 4 seconds. The delay is to wait for the blocks to be fully loaded
	//setTimeout(function() { fm_runTabs(); }, 4000);
} else {
	// This runs on the front end of the site
	document.addEventListener('DOMContentLoaded', function() { fm_runTabs(); });
}